import summaryCommonStore from "@/store/summaryCommon.store";
import MobileSummary from "../MobileSummary";
import useFetchSummary from "../Summary/useFetchSummary";

const MobileShareWrap = () => {
  useFetchSummary(summaryCommonStore.getState().streamId, true);

  return <MobileSummary fromShare={true} />;
};

export default MobileShareWrap;
